export default {
  title: 'Historique des modifications du menu',
  subtitle: 'Consultez qui a modifié les prix, la disponibilité et la visibilité pour {{company}} — et quand.',
  filters: {
    type: {
      label: 'Type',
    },
    item: {
      placeholder: 'Tous les éléments',
    },
    event: {
      label: 'Événement',
    },
  },
  columns: {
    when: 'Quand',
    who: 'Modifié par',
    type: 'Type',
    item: 'Élément',
    event: 'Événement',
    changes: 'Modifications',
  },
  types: {
    product: 'Produit',
    modifier: 'Modificateur',
    category: 'Catégorie',
    modifier_group: 'Groupe de modificateurs',
    menu: 'Menu',
  },
  events: {
    created: 'Créé',
    updated: 'Mis à jour',
    deleted: 'Supprimé',
  },
  fields: {
    name: 'Nom',
    description: 'Description',
    price: 'Prix',
    is_available: 'Disponibilité',
    is_visible: 'Visibilité',
    is_available_for_pickup: 'Disponibilité retrait',
    is_available_for_delivery: 'Disponibilité livraison',
    tax_category_id: 'Catégorie de taxe',
    schedule: "Horaires d'affichage",
    is_required: 'Obligatoire',
    max_count: 'Nombre max. de choix',
  },
  // A dish's price per order method that a price change worked out again (QA24): each its own line.
  order_method_prices: {
    pickup: 'Prix à emporter',
    delivery: 'Prix de livraison',
    dine_in: 'Prix sur place',
    room_service: 'Prix room service',
  },
  booleans: {
    on: 'Disponible',
    off: 'Indisponible',
    yes: 'Oui',
    no: 'Non',
  },
  schedule: {
    always: 'Toujours',
    every_day: 'Tous les jours',
  },
  pagination: {
    previous: 'Précédent',
    next: 'Suivant',
  },
  causers: {
    undo: 'Annuler',
    orders_terminal: 'Terminal de commandes',
    approved_by: {
      amigo: 'Amigo, approuvé par {{name}}',
      assistant: 'Assistant, approuvé par {{name}}',
    },
  },
  // Only our team sees it (the Amigo log is FoodAmigos-internal).
  open_agent_log: 'Ouvrir dans le journal Amigo',
  system: 'Système',
  empty_value: '—',
  toasts: {
    failed_to_load_data: "Échec du chargement de l'historique des modifications du menu",
  },
};
